import { ReactNode } from 'react';

import { Box, SxProps, Theme } from '@mui/material';

type OnboardingStepContainerProps = Readonly<{
  children: ReactNode;
}>;

export const OnboardingStepContainer = ({ children }: OnboardingStepContainerProps) => (
  <Box sx={containerStyle}>{children}</Box>
);

const containerStyle: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',

  paddingTop: backrs.spacing['spacing-3xl'],
  paddingX: backrs.spacing['spacing-md'],
  paddingBottom: backrs.spacing['spacing-3xl'],

  width: '100%',
  margin: '0 auto',

  maxHeight: '100dvh',
  overflowY: 'auto',
  boxSizing: 'border-box',

  backgroundColor: backrs.colors['Colors/Base/White'],
  borderRadius: backrs.radius['radius-md'],
});
